import { useMutateOnRefresh } from '@va/dashboard/util-hooks';
import { useNumberOfVisitsByDay } from './apiClient';
import TrafficChartCard from './TrafficChartCard';

const VisitsByDayChart = () => {
  const { data, isLoading, mutate } = useNumberOfVisitsByDay();

  const { isManualRefreshing } = useMutateOnRefresh(mutate);

  return (
    <TrafficChartCard data={data} isLoading={isLoading || isManualRefreshing} baseKey='trafficPageLoadsByWeekDays' />
  );
};

export default VisitsByDayChart;
